/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 * Page Account Info Translations Constants
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.10.0
 */

import { IPageAccountInfoTranslation } from '../../types/pages/pageAccountInfoTranslation';

export const initPageAccountInfoTranslation: IPageAccountInfoTranslation = {
    delivery: {
        addressString: '',
        buttonCancel: '',
        buttonSave: '',
        contactPerson: '',
        email: '',
        mandatoryFieldsHint: '',
        note: '',
        phone: '',
        title: '',
        infoText: '',
        useCourier: '',
        useEdm: '',
        useEmail: '',
        usePost: '',
        edmInfoBlockTitle: '',
        edmInfoBlockText: '',
        details: '',
        inquiryStatuses: {
            changing: '',
            connectiong: '',
        },
        tooltipText: '',
        emailChangeHint: '',
    },
    error: {
        codes: {},
        defaultMessage: '',
    },
    success: {
        successMessage: '',
    },
    financialInfo: {
        otherTitle: '',
        campaigns: {
            campaignsCount: '',
            title: '',
        },
        unpaidBills: {
            more: '',
            none: '',
            title: '',
            unpaidAmount: '',
        },
        balances: {
            creditLimit: {
                hint: '',
                none: '',
                title: '',
            },
            currentBalance: {
                hint: '',
                onTime: '',
                title: '',
            },
            promisedPayments: {
                hint: '',
                onTime: '',
                title: '',
            },
            title: '',
            totalBalance: {
                hint: '',
                onTime: '',
                title: '',
            },
            virtualBalance: {
                hint: '',
                hintCashbackV1: '',
                onTime: '',
                title: '',
            },
        },
        accountPayments: {
            hint: '',
            onTime: '',
            title: '',
        },
        initialBalance: {
            hint: '',
            onTime: '',
            title: '',
        },
        subscribersCharges: {
            hint: '',
            onTime: '',
            title: '',
        },
        loyaltyUser: {
            linkCashbackControl: '',
            linkGetCashback: '',
            title: '',
            titleStatus: '',
            titleBalance: '',
            onTime: '',
        },
        promisedPayments: {
            buttonLabel: '',
            descrHtml: '',
            onTime: '',
            title: '',
            titleItem: '',
            titleConnect: '',
        },
        multiBalances: {
            card: {
                linkMore: '',
                originalBalanceTitle: '',
                remainingDate: '',
                remainingTitle: '',
                titleDates: '',
            },
            emptyList: '',
            historyModalFields: {},
            historyModalTitle: '',
            title: '',
            titleExhausted: '',
        },
        discounts: {
            infinite: '',
            total: '',
            noneDiscounts: '',
            restVolume: '',
            spentVolume: '',
            title: '',
            unlimited: '',
            untilDate: '',
        },
    },
    generalInfo: {
        fieldAddInfoContract: '',
        fieldAddInfoINN: '',
        fieldAddInfoKPP: '',
        fieldAddInfoSubsCount: '',
        fieldCompanySectorName: '',
        fieldCompanyStaffCount: '',
        fieldJurAddress: '',
        fieldJurContactName: '',
        fieldJurContactPhone: '',
        fieldJurEmail: '',
        fieldJurLeaderName: '',
        fieldName: '',
        fieldPersonalManager: '',
        fieldSubdivisionName: '',
        fieldVerificationDate: '',
        fieldVerificationRegistrationData: '',
        noFieldValue: '',
        warningInfo: '',
    },
    tabs: {
        financialInfo: '',
        financialInfoDiscounts: '',
        financialInfoGeneral: '',
        financialInfoMultiBalances: '',
        generalInfo: '',
        shippingAccs: '',
    },
    title: '',
}
